import {
  NeedsDriversLicensePhotoUploadedDriversLicensePhotoDto,
  NeedsToBeMovedToStagingDetailsDto,
  NeedsToBeMovedToStagingWarrantyCertPhotoDto
} from 'dtos'
import OutboundTripNeedsDriversLicensePhotoUploadedHeroCard from './OutboundTripNeedsDriversLicensePhotoUploadedHeroCard'
import Step1DriversLicensePhoto from './Step1DriversLicensePhoto'
import Step2DriversLicensePhotoReview from './Step2DriversLicensePhotoReview'
import { ArrowBack } from '@mui/icons-material'
import { Grid, Card, CardContent, Typography, Button } from '@mui/material'
import { useLayout } from 'context'
import { enqueueSnackbar } from 'notistack'
import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { NeedsDriversLicensePhotoUploadedDetailsDto } from 'dtos/needsDriversLicensePhotoUploadedDetailsDto'
import * as controllers from 'controllers'

export interface OutboundTripNeedsDriversLicensePhotoUploadedPhotoProps {
  driversLicensePhoto: NeedsDriversLicensePhotoUploadedDriversLicensePhotoDto
  setDriversLicensePhoto: React.Dispatch<React.SetStateAction<NeedsDriversLicensePhotoUploadedDriversLicensePhotoDto>>
}

export default function OutboundTripNeedsDriversLicensePhotoUploaded() {
  const { outboundTripGuid } = useParams()
  const layout = useLayout()
  const navigate = useNavigate()

  const [initialValues, setInitialValues] = useState<NeedsDriversLicensePhotoUploadedDetailsDto>(
    new NeedsDriversLicensePhotoUploadedDetailsDto()
  )

  const [activeStep, setActiveStep] = useState<number>(0)
  const [driversLicensePhoto, setDriversLicensePhoto] = useState<NeedsDriversLicensePhotoUploadedDriversLicensePhotoDto>(
    new NeedsDriversLicensePhotoUploadedDriversLicensePhotoDto()
  )

  useEffect(() => {
    if (outboundTripGuid) {
      layout.setIsLayoutLoading(true)
      controllers.outboundTrips
        .getNeedsDriversLicensePhotoUploadedDetails(outboundTripGuid)
        .then(response => {
          setInitialValues(response.value)
        })
        .finally(() => {
          layout.setIsLayoutLoading(false)
        })

      controllers.outboundTrips
        .getNeedsDriversLicensePhotoUploadedDriversLicensePhotoInformation(outboundTripGuid)
        .then(response => {
          setDriversLicensePhoto(response.value)
        })
    }
  }, [outboundTripGuid])

  const onBack = () => {
    setActiveStep(prev => Math.max(0, prev - 1))
  }

  const onNext = () => {
    setActiveStep(prev => Math.min(3, prev + 1))
  }

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container justifyContent='space-between'>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  Needs Drivers License Uploaded
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto' container spacing={2} alignItems='center' justifyContent='flex-end'>
                <Grid item>
                  <Button
                    onClick={() => {
                      navigate('/to-do-list')
                    }}
                    color='primary'
                    startIcon={<ArrowBack />}
                    variant='text'
                  >
                    BACK
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <OutboundTripNeedsDriversLicensePhotoUploadedHeroCard outboundTrip={initialValues} />
      </Grid>

      {activeStep === 0 && (
        <Grid item xs={12}>
          <Step1DriversLicensePhoto
            onNext={onNext}
            needsDriversLicensePhotoUploadedDetails={initialValues}
            outboundTripGuid={outboundTripGuid}
            driversLicensePhoto={driversLicensePhoto}
            setDriversLicensePhoto={setDriversLicensePhoto}
          />
        </Grid>
      )}

      {activeStep === 1 && (
        <Grid item xs={12}>
          <Step2DriversLicensePhotoReview
            onBack={onBack}
            onNext={() => {
              layout.setIsLayoutLoading(true)

              controllers.outboundTrips
                .updateNeedsDriversLicensePhotoUploadedDetails(outboundTripGuid!, initialValues)
                .then(response => {
                  enqueueSnackbar('Drivers License Photo Uploaded Successfully!', { variant: 'success' })
                  navigate('/to-do-list', { replace: true })
                })
                .finally(() => {
                  layout.setIsLayoutLoading(false)
                })
            }}
            outboundTripNeedsDriversLicensePhotoUploadedDetails={initialValues}
            outboundTripGuid={outboundTripGuid}
            driversLicensePhoto={driversLicensePhoto}
            setDriversLicensePhoto={setDriversLicensePhoto}
          />
        </Grid>
      )}
    </Grid>
  )
}
